var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',[_c('CoreSearchFiltersTheSwitch',{attrs:{"value":_vm.selected},on:{"emit-update":_vm.emitUpdate}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"m-0"},[_vm._v("Vedi tutte le inserzioni già bandite")])])
}]

export { render, staticRenderFns }